import { render, staticRenderFns } from "./static-article-card.vue?vue&type=template&id=03c5c094&"
import script from "./static-article-card.vue?vue&type=script&lang=js&"
export * from "./static-article-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports